import { render, staticRenderFns } from "./WalkTimes.vue?vue&type=template&id=0aeb58f8&"
import script from "./WalkTimes.vue?vue&type=script&lang=ts&"
export * from "./WalkTimes.vue?vue&type=script&lang=ts&"
import style0 from "./WalkTimes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QSpace,QBtn,QBadge,QSeparator,QCheckbox,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QIcon,QSpace,QBtn,QBadge,QSeparator,QCheckbox})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
